import * as React from 'react'

const CardIcon = () => (
  <svg
    width="45"
    height="29"
    viewBox="0 0 45 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.88127 28.344H3.32119C2.70557 28.344 2.11517 28.0994 1.67986 27.6641C1.24455 27.2288 1 26.6384 1 26.0228V3.32119C1 2.70557 1.24455 2.11517 1.67986 1.67986C2.11517 1.24455 2.70557 1 3.32119 1H41.9584C42.574 1 43.1644 1.24455 43.5997 1.67986C44.035 2.11517 44.2796 2.70557 44.2796 3.32119V26.0228C44.2796 26.6384 44.035 27.2288 43.5997 27.6641C43.1644 28.0994 42.574 28.344 41.9584 28.344H14.211"
      fill="white"
    />
    <path
      d="M7.88127 28.344H3.32119C2.70557 28.344 2.11517 28.0994 1.67986 27.6641C1.24455 27.2288 1 26.6384 1 26.0228V3.32119C1 2.70557 1.24455 2.11517 1.67986 1.67986C2.11517 1.24455 2.70557 1 3.32119 1H41.9584C42.574 1 43.1644 1.24455 43.5997 1.67986C44.035 2.11517 44.2796 2.70557 44.2796 3.32119V26.0228C44.2796 26.6384 44.035 27.2288 43.5997 27.6641C43.1644 28.0994 42.574 28.344 41.9584 28.344H14.211"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0378 28.3359H10.1035"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.2796 5.32129H1V12.5647H44.2796V5.32129Z"
      fill="#005AA3"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.5749 24.8706C38.9843 24.8706 40.9375 22.9174 40.9375 20.508C40.9375 18.0987 38.9843 16.1455 36.5749 16.1455C34.1656 16.1455 32.2124 18.0987 32.2124 20.508C32.2124 22.9174 34.1656 24.8706 36.5749 24.8706Z"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.4104 24.8706C32.8197 24.8706 34.7729 22.9174 34.7729 20.508C34.7729 18.0987 32.8197 16.1455 30.4104 16.1455C28.001 16.1455 26.0479 18.0987 26.0479 20.508C26.0479 22.9174 28.001 24.8706 30.4104 24.8706Z"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25146 17.9727H9.28072"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25143 21.0595H12.0381"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CardIcon
